// Copyright (c) 2016 Deere & Company

import actions from '../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/is-editable.js